import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
  Errors,
  FileService,
  LocalService,
  ManagerService,
  SellerService,
} from 'src/app/core';
import { sellerApi } from 'src/app/config';
import { TabItem } from 'src/app/shared/components/tabs/tabs.component';
import { DataTableColumn } from 'src/app/shared/ui/data-table/data-table.component';
import { BadgeVariant } from 'src/app/shared/ui/badge/badge.component';

@Component({
  selector: 'app-claimed-earnings',
  templateUrl: './claimed-earnings.component.html',
  styleUrls: ['./claimed-earnings.component.scss'],
})
export class ClaimedEarningsComponent implements OnInit, AfterViewInit {
  @ViewChild('dateTemplate') dateTemplate!: TemplateRef<any>;
  @ViewChild('pointsEarnedTemplate') pointsEarnedTemplate!: TemplateRef<any>;
  @ViewChild('poStatusTemplate') poStatusTemplate!: TemplateRef<any>;
  @ViewChild('submittedDateTemplate') submittedDateTemplate!: TemplateRef<any>;
  @ViewChild('pendingStatusTemplate') pendingStatusTemplate!: TemplateRef<any>;

  subTabs: TabItem[] = [];
  activeSubTabId = 'subtab-1';
  viewDealsFlag: Boolean = true;

  searchData = '';
  searchCustomer = '';
  searchPendingCustomer = '';

  rewardType: any = '';
  rewardTypeOptions: any[] = [];

  statusOptions: any[] = [
    { label: 'All Status', value: 'all' },
    { label: 'Approved', value: 'APPROVED' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Denied', value: 'DENIED' }
  ];
  selectedStatusOption: any = { label: 'All Status', value: 'all' };

  claimedDeals: any;
  pendingClaimedDeals: any;

  claimedDealsTableColumns: DataTableColumn[] = [];
  pendingClaimsTableColumns: DataTableColumn[] = [];

  claimedDealsPage = 0;
  pendingPage = 0;
  size = 5;

  claimedDealsSortBy: any = null;
  pendingClaimsSortBy: any = null;
  sortByCustomer: any;
  sortByPendingCustomer: any;

  isClaimedDealsTableLoading = false;
  isPendingClaimsTableLoading = false;

  userProfile: any;
  errors: Errors = { errors: {} };

  constructor(
    private sellerService: SellerService,
    private managerService: ManagerService,
    private fileService: FileService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.buildSubTabs();
    this.buildRewardTypeOptions();
    this.loadCompanyPreferences();
  }

  ngAfterViewInit() {
    this.initializeClaimedDealsTableColumns();
    this.initializePendingClaimsTableColumns();
  }

  private loadCompanyPreferences() {
    if (
      this.userProfile &&
      this.userProfile.company &&
      this.userProfile.company.id
    ) {
      const companyParams = { companyId: this.userProfile.company.id };
      this.managerService.getCompanyPreferences(companyParams).subscribe(
        (data: any) => {
          const preferences = data.companyPreferences.map(
            (item: any) => item.enabled
          );
          const companyRewardTypeSel = preferences[11];
          if (companyRewardTypeSel) {
            this.rewardType = 'POINTS';
          } else {
            this.rewardType = 'CASH';
          }
          if (preferences[11] === false && preferences[12] === false) {
            this.rewardType = 'POINTS';
          }
          this.getClaimedDeals();
        },
        (err: any) => {
          this.errors = err;
        }
      );
    }
  }

  buildSubTabs() {
    this.subTabs = [
      { id: 'subtab-1', label: 'adminClaim.subtab1' },
      { id: 'subtab-0', label: 'manageClaims.subTabs4' },
    ];
    this.activeSubTabId = this.viewDealsFlag ? 'subtab-1' : 'subtab-0';
  }

  buildRewardTypeOptions() {
    this.rewardTypeOptions = [
      {
        label: this.translate.instant('manageClaims.pointsEarning'),
        value: 'POINTS',
      },
      {
        label: this.translate.instant('manageClaims.cashEarning'),
        value: 'CASH',
      },
    ];
  }

  onSubTabChange(tab: TabItem) {
    const isDealsTab = tab.id === 'subtab-1';
    this.changeViewDeals(isDealsTab);
  }

  changeViewDeals(flag: boolean) {
    if (this.viewDealsFlag === flag) {
      return;
    }
    this.viewDealsFlag = flag;
    this.size = 5;
    if (flag === true) {
      this.claimedDealsPage = 0;
      this.searchCustomer = '';
      this.sortByCustomer = null;
      this.getClaimedDeals();
    } else {
      this.pendingPage = 0;
      this.searchPendingCustomer = '';
      this.sortByPendingCustomer = null;
      this.getPendingClaimedDeals();
    }
  }

  initializeClaimedDealsTableColumns(): void {
    this.claimedDealsTableColumns = [
      {
        field: 'bookingDate',
        header: this.translate.instant('adminClaim.th14'),
        sortable: true,
        cellTemplate: this.dateTemplate,
        align:'center'
      },
      {
        field: 'poNumber',
        header: this.translate.instant('adminClaim.th4'),
         align:'center'
      },
      {
        field: 'customerName',
        header: this.translate.instant('adminClaim.th6'),
         align:'center'
      },
      {
        field: 'challengeId',
        header: this.translate.instant('adminClaim.th15'),
         align:'center'
      },
      {
        field: 'pointsEarned',
        header: this.translate.instant('adminClaim.th16'),
        cellTemplate: this.pointsEarnedTemplate,
        align: 'center',
        isBold: true,
      },
      {
        field: 'poStatus',
        header: this.translate.instant('adminClaim.th17'),
        cellTemplate: this.poStatusTemplate,
      },
      {
        field: 'comments',
        align:'center',
        header: this.translate.instant('adminClaim.th18'),
      },
    ];
    this.cdr.markForCheck();
  }

  initializePendingClaimsTableColumns(): void {
    this.pendingClaimsTableColumns = [
      {
        field: 'poNumber',
        header: this.translate.instant('manageClaims.manageTh3'),
      },
      {
        field: 'submittedOn',
        header: this.translate.instant('manageClaims.manageTh4'),
        sortable: true,
        cellTemplate: this.submittedDateTemplate,
      },
      {
        field: 'offer',
        header: this.translate.instant('manageClaims.manageTh14'),
      },
      {
        field: 'status',
        header: this.translate.instant('manageClaims.manageTh12'),
        cellTemplate: this.pendingStatusTemplate,
      },
    ];
    this.cdr.markForCheck();
  }

  getClaimedDeals() {
    if (!this.rewardType) {
      return;
    }
    this.isClaimedDealsTableLoading = true;
    const params: any = {
      page: this.claimedDealsPage,
      size: this.size,
      userIds: this.userProfile.id,
      pointsRewardType: this.rewardType,
    };
    if (this.sortByCustomer) {
      params['sortBy'] = this.sortByCustomer.active;
      params['sortDir'] = this.sortByCustomer.direction;
    }
    if (this.searchCustomer) {
      params['searchText'] = this.searchCustomer;
    }
    if (this.selectedStatusOption && this.selectedStatusOption.value !== 'all') {
      params['claimStatus'] = this.selectedStatusOption.value;
    }
    this.sellerService.claimedDeals(params).subscribe(
      (data: any) => {
        this.claimedDeals = data;
        this.isClaimedDealsTableLoading = false;
      },
      (err: any) => {
        this.errors = err;
        this.isClaimedDealsTableLoading = false;
      }
    );
  }

  getPendingClaimedDeals() {
    this.isPendingClaimsTableLoading = true;
    const params: any = {
      page: this.pendingPage,
      size: this.size,
    };
    if (this.sortByPendingCustomer) {
      params['sortBy'] = this.sortByPendingCustomer.active;
      params['sortDir'] = this.sortByPendingCustomer.direction;
    }
    if (this.searchPendingCustomer) {
      params['searchText'] = this.searchPendingCustomer;
    }
    this.sellerService.pendingClaimedDeals(params).subscribe(
      (data: any) => {
        this.pendingClaimedDeals = data;
        this.isPendingClaimsTableLoading = false;
      },
      (err: any) => {
        this.errors = err;
        this.isPendingClaimsTableLoading = false;
      }
    );
  }

  onClaimedDealsSortChange(sortEvent: any) {
    this.claimedDealsSortBy = {
      active: sortEvent.sortBy,
      direction: sortEvent.sortDir.toLowerCase(),
    };
    this.sortByCustomer = this.claimedDealsSortBy;
    this.sortByCustomer.direction = this.sortByCustomer.direction.toUpperCase();
    this.claimedDealsPage = 0;
    this.getClaimedDeals();
  }

  onClaimedDealsPageChange(page: number) {
    this.claimedDealsPage = page - 1;
    this.getClaimedDeals();
  }

  onPendingClaimsPageChange(page: number) {
    this.pendingPage = page - 1;
    this.getPendingClaimedDeals();
  }

  onPendingClaimsSortChange(sortEvent: any) {
    this.pendingClaimsSortBy = {
      active: sortEvent.sortBy,
      direction: sortEvent.sortDir.toLowerCase(),
    };
    this.sortByPendingCustomer = this.pendingClaimsSortBy;
    this.sortByPendingCustomer.direction = this.sortByPendingCustomer.direction.toUpperCase();
    this.pendingPage = 0;
    this.getPendingClaimedDeals();
  }

  onStatusFilterChange(selected: any): void {
    this.selectedStatusOption = selected;
    this.claimedDealsPage = 0;
    this.getClaimedDeals();
  }

  searchCustomerName(value: string, flag?: boolean) {
    if (!flag) {
      this.searchCustomer = value;
      if (value.length > 0) {
        this.claimedDealsPage = 0;
        this.getClaimedDeals();
      }
    }
    if (flag && value.length === 0) {
      this.claimedDealsPage = 0;
      this.searchCustomer = '';
      this.getClaimedDeals();
    }
  }

  searchPendingCustomerName(value: string, flag?: boolean) {
    if (!flag) {
      this.searchPendingCustomer = value;
      if (value.length > 0) {
        this.pendingPage = 0;
        this.getPendingClaimedDeals();
      }
    }
    if (flag && value.length === 0) {
      this.pendingPage = 0;
      this.searchPendingCustomer = '';
      this.getPendingClaimedDeals();
    }
  }

  downloadExcel() {
    const url: string =
      sellerApi.claimStatusHistory +
      `?page=0&size=100000&userId=${this.userProfile.id}&excel=true` +
      '&pointsRewardType=' +
      this.rewardType;
    const fileName: string =
      'Claim_Status_History_' + this.userProfile.company.id + '.xlsx';
    this.fileService.excelDownloadFile(url, fileName);
  }

  getStatusVariant(status: string): BadgeVariant {
    if (status === 'APPROVED') { return 'success'; }
    if (status === 'PENDING') { return 'warning'; }
    if (status === 'DENIED') { return 'error'; }
    return 'secondary';
  }

  splitData(value: string) {
    const parseValue = parseFloat(value);
    const newData = parseValue.toLocaleString();
    return newData.toString();
  }
}
